import {TranslateService} from '@ngx-translate/core';
import {MatPaginatorIntl} from '@angular/material';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();

    this.translate.onLangChange.subscribe((e: Event) => {
      this.getTranslations();
    });

    this.getTranslations();
  }

  getTranslations() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.itemsPerPageLabel = this.translate.instant('PAGINATOR.itemsPerPage');
      this.firstPageLabel = this.translate.instant('PAGINATOR.firstPage');
      this.nextPageLabel = this.translate.instant('PAGINATOR.nextPage');
      this.previousPageLabel = this.translate.instant('PAGINATOR.previousPage');
      this.lastPageLabel = this.translate.instant('PAGINATOR.lastPage');
      this.changes.next();
    });
  }

 getRangeLabel = (page: number, pageSize: number, length: number) =>  {
    if (length === 0 || pageSize === 0) {
      return `0 - ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }
}